export default {
  currentTimeSec: state => state.currentTimeSec,
  currentUserTimeSec: state => state.userTimeSec,
};
